// Pure rules behind the team-definition banner (kanban 16a22d06): which
// registry rows the selected teams map to.
import type { TeamMandate } from '../../services/roadmapReports';

export const foldTeamName = (t: string) => t.split(/\s+/).filter(Boolean).join(' ').toLowerCase();

/** The registry rows for the selected teams, in selection order; a selected
 * team with no registry row still gets an entry (null) so the banner can say
 * it has no definition on record. */
export function briefsFor(teams: readonly string[], mandates: readonly TeamMandate[]): Array<{ team: string; mandate: TeamMandate | null }> {
  const byTeam = new Map(mandates.map((m) => [foldTeamName(m.team), m]));
  return teams.map((team) => {
    const m = byTeam.get(foldTeamName(team)) ?? null;
    return { team: m?.team ?? team, mandate: m };
  });
}

